export const wait = (ms?: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms || 500))
}
